/* brbserv-metalstore — theme JS */
(function () {
  'use strict';

  // ============= Smart header — appears on first scroll-up, then stays pinned until back at top =============
  (function () {
    var header = document.querySelector('.brb-header');
    if (!header) return;
    header.style.transform = '';   // drop any leftover inline transform

    /* Body spacer must reflect the UNCOLLAPSED header height — otherwise once the menubar
       collapses (.is-scrolled), a re-measure would shrink the spacer and content would slide
       under the header when it expands back. We measure only while not collapsed. */
    var lastFullHeight = 0;
    function syncSpacer() {
      if (header.classList.contains('is-scrolled')) return;
      var h = header.offsetHeight;
      if (h && h !== lastFullHeight) {
        lastFullHeight = h;
        document.documentElement.style.setProperty('--brb-header-h', h + 'px');
      }
    }
    syncSpacer();
    window.addEventListener('resize', syncSpacer, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(syncSpacer).observe(header);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncSpacer);
    window.addEventListener('load', syncSpacer);
    /* Restore from bfcache: header state may be stale, force a recompute. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) { update(); syncSpacer(); } });

    var threshold = 60;
    var lastY = window.pageYOffset || 0;
    var revealed = false;

    function update() {
      var y = window.pageYOffset || 0;
      var delta = y - lastY;

      if (y <= threshold) {
        revealed = false;
        header.classList.remove('is-scrolled');
        header.classList.remove('is-hidden');
        syncSpacer();
      } else {
        header.classList.add('is-scrolled');
        if (delta < 0) revealed = true;
        if (revealed) {
          header.classList.remove('is-hidden');
        } else {
          header.classList.add('is-hidden');
        }
      }
      lastY = y;
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  // ============= Currency formatter (locale-aware) =============
  var BRB_CURRENCY = (document.body.dataset.currency || 'RON').toUpperCase();
  var BRB_LOCALE   = document.body.dataset.locale || 'ro-RO';
  function brbMoney(cents) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    try {
      return new Intl.NumberFormat(BRB_LOCALE, { style: 'currency', currency: BRB_CURRENCY }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + BRB_CURRENCY;
    }
  }
  window.brbMoney = brbMoney;

  // ============= Toast =============
  function brbToast(message, type) {
    var stack = document.getElementById('brbToastStack');
    if (!stack) {
      stack = document.createElement('div');
      stack.id = 'brbToastStack';
      stack.className = 'brb-toast-stack';
      document.body.appendChild(stack);
    }
    var t = document.createElement('div');
    t.className = 'brb-toast ' + (type ? 'is-' + type : '');
    t.textContent = message;
    stack.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('open'); });
    setTimeout(function () {
      t.classList.remove('open');
      setTimeout(function () { t.remove(); }, 250);
    }, 3200);
  }
  window.brbToast = brbToast;

  // ============= Cart drawer =============
  function brbOpenCart() {
    var drawer = document.getElementById('brbCartDrawer');
    var overlay = document.getElementById('brbCartOverlay');
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.classList.add('open');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('open'); }); }
    document.documentElement.classList.add('brb-no-scroll');
    brbRefreshCart();
  }
  function brbCloseCart() {
    var drawer = document.getElementById('brbCartDrawer');
    var overlay = document.getElementById('brbCartOverlay');
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) { overlay.classList.remove('open'); setTimeout(function () { overlay.hidden = true; }, 250); }
    document.documentElement.classList.remove('brb-no-scroll');
  }
  function brbRefreshCart() {
    var body = document.getElementById('brbCartDrawerBody');
    if (!body) return;
    body.classList.add('is-busy');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-cart-count', cart.item_count);
      });
      var subtotal = document.getElementById('brbCartDrawerSubtotal');
      if (subtotal) subtotal.textContent = brbMoney(cart.items_subtotal_price);
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="brb-cd-empty"><p>Coșul tău este gol.</p><a href="/collections/all" class="btn btn-primary"><span>Continuă cumpărăturile</span><span class="arrow">→</span></a></div>';
      } else {
        body.innerHTML = cart.items.map(function (it) {
          return '<div class="brb-cd-item" data-key="' + it.key + '">' +
            '<a class="brb-cd-img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '<div class="brb-cd-img-ph"></div>') + '</a>' +
            '<div class="brb-cd-info">' +
              '<a class="brb-cd-name" href="' + it.url + '">' + it.product_title + '</a>' +
              (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="brb-cd-var">' + it.variant_title + '</span>' : '') +
              '<div class="brb-cd-row">' +
                '<div class="brb-cd-qty">' +
                  '<button type="button" data-q="-" data-key="' + it.key + '" aria-label="Scade">−</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-q="+" data-key="' + it.key + '" aria-label="Crește">+</button>' +
                '</div>' +
                '<span class="brb-cd-price">' + brbMoney(it.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="brb-cd-remove" data-rm="' + it.key + '" aria-label="Elimină">×</button>' +
          '</div>';
        }).join('');
      }
      body.classList.remove('is-busy');
    }).catch(function () { body.classList.remove('is-busy'); });
  }
  function brbChangeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { brbRefreshCart(); });
  }
  window.brbOpenCart = brbOpenCart;
  window.brbCloseCart = brbCloseCart;
  window.brbRefreshCart = brbRefreshCart;

  document.addEventListener('click', function (e) {
    var openLink = e.target.closest('[data-open-cart], a.cart, .brb-mnav-cart');
    if (openLink && document.getElementById('brbCartDrawer') && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      brbOpenCart();
      return;
    }
    var closeBtn = e.target.closest('[data-close-cart]');
    if (closeBtn) { e.preventDefault(); brbCloseCart(); return; }
    var ovl = e.target.closest('#brbCartOverlay');
    if (ovl) { brbCloseCart(); return; }
    var qBtn = e.target.closest('[data-q]');
    if (qBtn) {
      var key = qBtn.dataset.key;
      var row = qBtn.closest('.brb-cd-item');
      var cur = row ? parseInt(row.querySelector('.brb-cd-qty span').textContent, 10) || 1 : 1;
      var next = qBtn.dataset.q === '+' ? cur + 1 : Math.max(1, cur - 1);
      brbChangeLine(key, next);
      return;
    }
    var rmBtn = e.target.closest('[data-rm]');
    if (rmBtn) { brbChangeLine(rmBtn.dataset.rm, 0); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = document.getElementById('brbCartDrawer');
      if (d && d.classList.contains('open')) brbCloseCart();
    }
  });

  // ============= FAQ accordion =============
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', function () { item.classList.toggle('open'); });
  });

  // ============= Finish swatches =============
  (function () {
    var swatches = document.querySelectorAll('.fin-swatch');
    if (!swatches.length) return;
    var nameEl = document.getElementById('finName');
    var ralEl  = document.getElementById('finRal');
    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        swatches.forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        if (nameEl) nameEl.textContent = s.dataset.name || '';
        if (ralEl)  ralEl.textContent  = s.dataset.ral  || '';
      });
    });
  })();

  // ============= Hero slider =============
  (function () {
    var slider = document.getElementById('brb-slider');
    if (!slider) return;
    var slides = slider.querySelectorAll('.slide');
    var dots   = slider.querySelectorAll('.slider-dot');
    var prev   = slider.querySelector('[data-slide-prev]');
    var next   = slider.querySelector('[data-slide-next]');
    if (slides.length < 2) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(slider.dataset.interval, 10) || 6000;
    var idx = 0; var timer; var paused = false;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('active', n === idx); });
      dots.forEach(function   (d, n) { d.classList.toggle('active', n === idx); });
    }
    function start() {
      if (reduceMotion || paused) return;
      clearInterval(timer);
      timer = setInterval(function () { go(idx + 1); }, interval);
    }
    function stop() { clearInterval(timer); }
    function reset() { stop(); start(); }

    if (prev) prev.addEventListener('click', function () { go(idx - 1); reset(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); reset(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.goto, 10) || 0); reset(); });
    });

    // Pause on hover, focus-within, tab hidden
    slider.addEventListener('mouseenter', function () { paused = true; stop(); });
    slider.addEventListener('mouseleave', function () { paused = false; start(); });
    slider.addEventListener('focusin',  function () { paused = true; stop(); });
    slider.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    start();
  })();

  // ============= Mega menu hover + mobile click =============
  (function () {
    document.querySelectorAll('.menu-item[data-menu]').forEach(function (item) {
      var t;
      item.addEventListener('mouseenter', function () {
        clearTimeout(t);
        document.querySelectorAll('.menu-item').forEach(function (x) { x.classList.remove('open'); });
        item.classList.add('open');
      });
      item.addEventListener('mouseleave', function () {
        t = setTimeout(function () { item.classList.remove('open'); }, 150);
      });
      var btn = item.querySelector(':scope > button');
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        item.classList.toggle('open');
      });
    });
    // click outside to close
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.menu-item[data-menu]')) {
        document.querySelectorAll('.menu-item[data-menu].open').forEach(function (x) { x.classList.remove('open'); });
      }
    });
  })();

  // ============= Catalog: view toggle (grid/list) =============
  (function () {
    var toggle = document.querySelector('.view-toggle');
    var grid = document.getElementById('prodGrid');
    if (!toggle || !grid) return;
    toggle.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggle.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        grid.classList.toggle('is-list', btn.dataset.view === 'list');
      });
    });
  })();

  // ============= Catalog: sort = auto-submit form =============
  (function () {
    var sort = document.querySelector('.cat-toolbar .sort-select');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var form = sort.closest('form');
      if (form) form.submit();
    });
  })();

  // ============= Wishlist (localStorage) =============
  var BRB_FAV_KEY = 'brb_fav_v1';
  function brbFavList() {
    try { return JSON.parse(localStorage.getItem(BRB_FAV_KEY) || '[]'); } catch (e) { return []; }
  }
  function brbFavSave(list) {
    try { localStorage.setItem(BRB_FAV_KEY, JSON.stringify(list)); } catch (e) {}
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = list.length;
      el.setAttribute('data-fav-count', list.length);
    });
    var hideEmpty = document.querySelectorAll('[data-fav-empty]');
    hideEmpty.forEach(function (el) { el.hidden = list.length > 0; });
    document.dispatchEvent(new CustomEvent('brb:fav', { detail: { list: list } }));
  }
  function brbFavHas(handle) { return brbFavList().some(function (i) { return i.handle === handle; }); }
  function brbFavToggle(item) {
    var list = brbFavList();
    var idx = list.findIndex(function (i) { return i.handle === item.handle; });
    if (idx > -1) list.splice(idx, 1); else list.push(item);
    brbFavSave(list);
    return idx === -1;
  }
  window.brbFavList = brbFavList;
  window.brbFavToggle = brbFavToggle;
  window.brbFavHas = brbFavHas;

  function brbFavSync() {
    var list = brbFavList();
    document.querySelectorAll('.prod-card-fav, [data-fav-handle]').forEach(function (btn) {
      var card = btn.closest('[data-fav-handle]') || btn.closest('.prod-card');
      var handle = btn.dataset.favHandle || (card && card.getAttribute('data-fav-handle'));
      if (!handle) {
        var href = (card && card.getAttribute('href')) || '';
        var match = href.match(/\/products\/([^/?#]+)/);
        if (match) handle = match[1];
      }
      if (handle) btn.classList.toggle('active', list.some(function (i) { return i.handle === handle; }));
    });
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = list.length;
      el.setAttribute('data-fav-count', list.length);
    });
  }
  brbFavSync();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.prod-card-fav, [data-fav-toggle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var card = btn.closest('[data-fav-handle]') || btn.closest('.prod-card');
    var handle = btn.dataset.favHandle || (card && card.getAttribute('data-fav-handle'));
    var url   = btn.dataset.favUrl   || (card && card.dataset && card.dataset.favUrl);
    var title = btn.dataset.favTitle || (card && card.dataset && card.dataset.favTitle);
    var image = btn.dataset.favImage || (card && card.dataset && card.dataset.favImage);
    var price = btn.dataset.favPrice || (card && card.dataset && card.dataset.favPrice);
    var desc  = btn.dataset.favDesc  || (card && card.dataset && card.dataset.favDesc);
    /* Fall back to scraping the card's children for any missing field — the
       grid cards have data-fav-handle but not the other data-fav-* attrs. */
    if (card) {
      var href = card.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      if (!handle && match) handle = match[1];
      if (!url) url = href;
      if (!title) { var nameEl = card.querySelector('.prod-card-name'); if (nameEl) title = nameEl.textContent.trim(); }
      if (!image) { var imgEl  = card.querySelector('.prod-card-img img, img'); if (imgEl) image = imgEl.src; }
      if (!price) { var pEl    = card.querySelector('.prod-card-price'); if (pEl) price = pEl.textContent.trim(); }
    }
    if (!handle) return;
    var added = brbFavToggle({ handle: handle, url: url, title: title, image: image, price: price, description: desc, addedAt: Date.now() });
    btn.classList.toggle('active', added);
    if (window.brbToast) brbToast(added ? 'Adăugat la favorite' : 'Eliminat din favorite');
  });

  // Render wishlist on /pages/favorites or any [data-fav-render]
  (function () {
    var wrap = document.getElementById('brbFavRender');
    if (!wrap) return;
    function escAttr(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return c === '&' ? '&amp;' : c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '"' ? '&quot;' : '&#39;';
      });
    }
    function render() {
      var list = brbFavList();
      /* Toggle the empty state in tandem with the list — brbFavSave only fires on toggles,
         so on initial page load the empty state needs to be hidden here too. */
      document.querySelectorAll('[data-fav-empty]').forEach(function (el) { el.hidden = list.length > 0; });
      if (!list.length) { wrap.innerHTML = ''; return; }
      wrap.innerHTML = list.map(function (i) {
        var url = escAttr(i.url || '#');
        var handle = escAttr(i.handle);
        var imgHTML = i.image
          ? '<img src="' + escAttr(i.image) + '" alt="' + escAttr(i.title || '') + '" loading="lazy">'
          : '<div class="ph-inner"></div>';
        var descHTML = i.description ? '<p class="brb-fav-row-desc">' + escAttr(i.description) + '</p>' : '';
        var priceHTML = i.price ? '<span class="brb-fav-row-price">' + escAttr(i.price) + '</span>' : '';
        return '<div class="brb-fav-row" data-fav-handle="' + handle + '">' +
          '<a class="brb-fav-row-image" href="' + url + '">' + imgHTML + '</a>' +
          '<div class="brb-fav-row-body">' +
            '<a class="brb-fav-row-title" href="' + url + '">' + escAttr(i.title || i.handle) + '</a>' +
            descHTML +
            priceHTML +
          '</div>' +
          '<button type="button" class="brb-fav-row-remove" data-fav-toggle data-fav-handle="' + handle + '" aria-label="Elimină din favorite">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M8 14s-5-3.3-5-7.2A3 3 0 0 1 8 4.5 3 3 0 0 1 13 6.8c0 3.9-5 7.2-5 7.2z"/></svg>' +
          '</button>' +
        '</div>';
      }).join('');
    }
    render();
    document.addEventListener('brb:fav', render);
  })();

  // ============= Mobile drawer =============
  (function () {
    var openBtn  = document.getElementById('brbMnavOpen');
    var closeBtn = document.getElementById('brbMnavClose');
    var overlay  = document.getElementById('brbMnavOverlay');
    var drawer   = document.getElementById('brbMnavDrawer');
    if (!openBtn || !drawer) return;

    function open() {
      drawer.classList.add('open');
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('open'); }); }
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('brb-no-scroll');
    }
    function close() {
      drawer.classList.remove('open');
      if (overlay) { overlay.classList.remove('open'); setTimeout(function () { overlay.hidden = true; }, 250); }
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('brb-no-scroll');
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
  })();

  // ============= Mobile filter drawer =============
  (function () {
    var toggle  = document.getElementById('brbFiltersToggle');
    var closeBtn = document.getElementById('brbFiltersClose');
    var overlay  = document.getElementById('brbFiltersOverlay');
    var drawer   = document.querySelector('.filters');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('brb-no-scroll');
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) { overlay.classList.remove('is-open'); setTimeout(function () { overlay.hidden = true; }, 250); }
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('brb-no-scroll');
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    /* If viewport grows past mobile breakpoint (orientation change, resize), reset to desktop state. */
    var mq = window.matchMedia('(min-width: 961px)');
    function syncToDesktop(e) { if (e.matches) close(); }
    if (mq.addEventListener) mq.addEventListener('change', syncToDesktop); else mq.addListener(syncToDesktop);
  })();

  // ============= Predictive search =============
  (function () {
    var input = document.querySelector('.brb-header .search-input');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;
    form.classList.add('brb-search-host');

    var panel = document.createElement('div');
    panel.className = 'brb-search-panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);

    var ctrl, lastQuery = '';
    function render(data) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        panel.innerHTML = '<div class="brb-search-empty">Niciun produs nu se potrivește.</div>';
        return;
      }
      panel.innerHTML = products.slice(0, 6).map(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<div class="brb-search-img-ph"></div>';
        var price = p.price ? '<span class="brb-search-price">' + p.price + '</span>' : '';
        return '<a class="brb-search-item" href="' + p.url + '">' +
          '<div class="brb-search-img">' + img + '</div>' +
          '<div class="brb-search-meta"><span class="brb-search-title">' + p.title + '</span>' + price + '</div>' +
        '</a>';
      }).join('') + '<a class="brb-search-all" href="/search?q=' + encodeURIComponent(input.value) + '"><span>Vezi toate rezultatele</span><span>→</span></a>';
    }
    function fetchSuggest(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      panel.hidden = false;
      panel.innerHTML = '<div class="brb-search-loading">Se caută…</div>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { signal: ctrl.signal })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { panel.hidden = true; lastQuery = ''; return; }
      if (q === lastQuery) return;
      lastQuery = q;
      t = setTimeout(function () { fetchSuggest(q); }, 180);
    });
    input.addEventListener('focus', function () { if (lastQuery) panel.hidden = false; });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) panel.hidden = true;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.hidden = true; });
  })();

  // ============= Search ⌘K focus =============
  (function () {
    var input = document.querySelector('.brb-header .search-input');
    if (!input) return;
    document.addEventListener('keydown', function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        input.focus();
      }
    });
  })();

  // ============= Product page =============
  (function () {
    var variantDataEl = document.getElementById('brbVariantData');
    if (!variantDataEl) return; // not on product page

    var variants = JSON.parse(variantDataEl.textContent);
    var selectedOptions = [];

    // ----- Gallery thumbnails -----
    var thumbsContainer = document.getElementById('brbProdThumbs');
    var mainImg = document.getElementById('brbMainImg');
    if (thumbsContainer && mainImg) {
      thumbsContainer.querySelectorAll('.brb-prod-thumb').forEach(function (btn) {
        btn.addEventListener('click', function () {
          thumbsContainer.querySelectorAll('.brb-prod-thumb').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = btn.dataset.src;
            mainImg.alt = btn.dataset.alt;
            mainImg.style.opacity = '1';
          }, 150);
        });
      });
    }

    // ----- Variant picker -----
    var optGroups = document.querySelectorAll('.brb-prod-opt-btns');
    optGroups.forEach(function (group) {
      var idx = parseInt(group.dataset.optIdx, 10);
      var active = group.querySelector('.brb-opt-btn.active');
      selectedOptions[idx] = active ? active.dataset.val : '';
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === (selectedOptions[i] || ''); });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;

      // Price
      var priceNow  = document.querySelector('.brb-price-now');
      var priceSave = document.querySelector('.brb-price-save');
      var priceWas  = document.querySelector('.brb-price-was');
      if (priceNow) priceNow.textContent = brbMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        if (priceSave) { priceSave.textContent = '−' + pct + '%'; priceSave.style.display = ''; }
        else if (priceNow) { var s = document.createElement('span'); s.className = 'brb-price-save'; s.textContent = '−' + pct + '%'; priceNow.parentNode.insertBefore(s, priceNow.nextSibling); priceSave = s; }
        var wasText = brbMoney(variant.compare_at_price);
        if (priceWas) { priceWas.textContent = wasText; priceWas.style.display = ''; }
        else if (priceSave) { var w = document.createElement('s'); w.className = 'brb-price-was'; w.textContent = wasText; priceSave.parentNode.insertBefore(w, priceSave.nextSibling); }
      } else {
        if (priceSave) priceSave.style.display = 'none';
        if (priceWas)  priceWas.style.display  = 'none';
      }

      // Variant hidden input
      var varId = document.getElementById('brbVarId');
      if (varId) varId.value = variant.id;

      // Stock badge + CTA
      var ctaEl = document.getElementById('brbProdCta');
      var badge = document.getElementById('brbStockBadge');
      if (variant.available) {
        // Show form, hide request
        var form = document.getElementById('brbAtcForm');
        var outActions = document.getElementById('brbOutActions');
        if (form) form.style.display = '';
        if (outActions) outActions.style.display = 'none';
        if (badge) { badge.className = 'brb-stock-badge brb-in-stock'; badge.querySelector('span:last-child').textContent = 'În stoc · livrare 2–3 săptămâni'; }
        if (ctaEl) { ctaEl.dataset.variantTitle = variant.title; ctaEl.dataset.variantId = variant.id; ctaEl.dataset.available = 'true'; }
      } else {
        var form2 = document.getElementById('brbAtcForm');
        var outActions2 = document.getElementById('brbOutActions');
        if (form2) form2.style.display = 'none';
        if (outActions2) outActions2.style.display = '';
        if (badge) { badge.className = 'brb-stock-badge brb-out-stock'; badge.querySelector('span:last-child').textContent = 'Stoc epuizat — trimite o cerere'; }
        if (ctaEl) { ctaEl.dataset.variantTitle = variant.title; ctaEl.dataset.variantId = variant.id; ctaEl.dataset.available = 'false'; }
      }

      // SKU
      var skuEl = document.getElementById('brbSku');
      if (skuEl) skuEl.textContent = variant.sku || '';

      // Image: switch to variant's featured image if different
      if (variant.featured_image && mainImg) {
        var newSrc = variant.featured_image.src.replace(/\?.*/, '') + '?width=1000';
        if (mainImg.src.split('?')[0] !== newSrc.split('?')[0]) {
          mainImg.style.opacity = '0';
          setTimeout(function () { mainImg.src = newSrc; mainImg.style.opacity = '1'; }, 150);
          // Sync thumbnails active state
          if (thumbsContainer) {
            thumbsContainer.querySelectorAll('.brb-prod-thumb').forEach(function (btn) {
              btn.classList.toggle('active', btn.dataset.src.split('?')[0] === newSrc.split('?')[0]);
            });
          }
        }
      }
    }

    optGroups.forEach(function (group) {
      var idx = parseInt(group.dataset.optIdx, 10);
      group.querySelectorAll('.brb-opt-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.brb-opt-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          selectedOptions[idx] = btn.dataset.val;
          var labelEl = document.getElementById('brbOptVal' + idx);
          if (labelEl) labelEl.textContent = btn.dataset.val;
          var variant = findVariant();
          if (variant) updateForVariant(variant);
        });
      });
    });

    // ----- Image zoom (lightbox) -----
    if (mainImg && document.querySelector('.brb-product-section [data-enable-zoom="true"], #brbProdMain')) {
      mainImg.style.cursor = 'zoom-in';
      mainImg.addEventListener('click', function () {
        var lb = document.createElement('div');
        lb.className = 'brb-lightbox';
        lb.innerHTML = '<button type="button" class="brb-lightbox-close" aria-label="Close">×</button>' +
          '<img src="' + mainImg.src.replace(/\bwidth=\d+/, 'width=2000') + '" alt="' + (mainImg.alt || '') + '">';
        document.body.appendChild(lb);
        document.documentElement.classList.add('brb-no-scroll');
        requestAnimationFrame(function () { lb.classList.add('open'); });
        function close() {
          lb.classList.remove('open');
          document.documentElement.classList.remove('brb-no-scroll');
          setTimeout(function () { lb.remove(); }, 200);
        }
        lb.addEventListener('click', function (e) {
          if (e.target === lb || e.target.classList.contains('brb-lightbox-close')) close();
        });
        document.addEventListener('keydown', function esc(e) {
          if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
        });
      });
    }

    // ----- Add to cart — AJAX (no redirect) -----
    var atcForm = document.getElementById('brbAtcForm');
    if (atcForm) {
      atcForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var varId  = document.getElementById('brbVarId');
        var qtyEl  = document.getElementById('brbQty');
        var btn    = atcForm.querySelector('[type="submit"]');
        var label  = btn ? btn.querySelector('span:first-child') : null;
        if (!varId) return;
        var payload = { items: [{ id: parseInt(varId.value, 10), quantity: parseInt(qtyEl ? qtyEl.value : 1, 10) || 1 }] };
        if (label) label.textContent = 'Se adaugă…';
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_add_failed');
          return r.json();
        })
        .then(function () {
          if (label) label.textContent = 'Adăugat ✓';
          brbToast('Adăugat în coș', 'ok');
          if (document.getElementById('brbCartDrawer')) {
            brbOpenCart();
          } else {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-cart-count', cart.item_count);
      });
            });
          }
          setTimeout(function () {
            if (label) label.textContent = 'Adaugă în coș';
            if (btn) btn.disabled = false;
          }, 2500);
        })
        .catch(function () {
          if (label) label.textContent = 'Eroare — încearcă din nou';
          if (btn) btn.disabled = false;
        });
      });
    }

    // ----- Quantity selector -----
    var qtyInput = document.getElementById('brbQty');
    if (qtyInput) {
      var qtyMinus = document.getElementById('brbQtyMinus');
      var qtyPlus  = document.getElementById('brbQtyPlus');
      if (qtyMinus) qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      if (qtyPlus) qtyPlus.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    // ----- Request button -----
    var reqBtn = document.getElementById('brbReqBtn');
    if (reqBtn) {
      reqBtn.addEventListener('click', function () {
        var ctaEl = document.getElementById('brbProdCta');
        if (!ctaEl) return;
        var item = {
          title:        ctaEl.dataset.title,
          handle:       ctaEl.dataset.handle,
          price:        ctaEl.dataset.price,
          url:          ctaEl.dataset.url,
          image:        ctaEl.dataset.image,
          variantTitle: ctaEl.dataset.variantTitle,
          addedAt:      Date.now()
        };
        var existing = [];
        try { existing = JSON.parse(sessionStorage.getItem('brb_requests') || '[]'); } catch (e) {}
        existing = existing.filter(function (r) { return r.handle !== item.handle; });
        existing.push(item);
        sessionStorage.setItem('brb_requests', JSON.stringify(existing));

        // Visual feedback before redirect
        reqBtn.querySelector('span:first-child').textContent = 'Adăugat!';
        setTimeout(function () { window.location.href = '/pages/contact?request=1'; }, 600);
      });
    }
  })();

  // ============= Cart — request banner =============
  (function () {
    var banner = document.getElementById('brbReqBanner');
    if (!banner) return;
    var reqs = [];
    try { reqs = JSON.parse(sessionStorage.getItem('brb_requests') || '[]'); } catch (e) {}
    if (!reqs.length) return;

    var itemsEl = document.getElementById('brbReqItems');
    if (itemsEl) {
      itemsEl.innerHTML = reqs.map(function (r) {
        return '<div class="brb-req-item">' +
          (r.image ? '<img src="' + r.image + '" alt="" class="brb-req-item-img" loading="lazy">' : '') +
          '<div class="brb-req-item-info">' +
            '<a href="' + r.url + '" class="brb-req-item-name">' + r.title + '</a>' +
            (r.variantTitle && r.variantTitle !== 'Default Title' ? '<div class="brb-req-item-var">' + r.variantTitle + '</div>' : '') +
          '</div>' +
          '<button type="button" class="brb-req-item-remove" data-handle="' + r.handle + '" aria-label="Elimină">×</button>' +
        '</div>';
      }).join('');

      itemsEl.querySelectorAll('.brb-req-item-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var reqs2 = [];
          try { reqs2 = JSON.parse(sessionStorage.getItem('brb_requests') || '[]'); } catch (e) {}
          reqs2 = reqs2.filter(function (r) { return r.handle !== btn.dataset.handle; });
          sessionStorage.setItem('brb_requests', JSON.stringify(reqs2));
          btn.closest('.brb-req-item').remove();
          if (!reqs2.length) banner.style.display = 'none';
        });
      });
    }

    banner.style.display = 'block';
  })();

  // ============= Contact — pre-fill din cereri =============
  (function () {
    if (!window.location.pathname.includes('/pages/contact')) return;
    if (!window.location.search.includes('request=1')) return;
    var reqs = [];
    try { reqs = JSON.parse(sessionStorage.getItem('brb_requests') || '[]'); } catch (e) {}
    if (!reqs.length) return;

    function fillForm() {
      var body = document.querySelector('textarea[name="contact[body]"]');
      if (!body) return;
      var lines = ['Bună ziua,\n\nSolicit informații despre disponibilitate și preț pentru:\n'];
      reqs.forEach(function (r, i) {
        var varStr = r.variantTitle && r.variantTitle !== 'Default Title' ? ' — ' + r.variantTitle : '';
        lines.push((i + 1) + '. ' + r.title + varStr + '\n   ' + window.location.origin + r.url);
      });
      lines.push('\n\nVă mulțumesc!');
      body.value = lines.join('\n');
      // Scroll to form
      body.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fillForm);
    } else {
      setTimeout(fillForm, 200); // wait for Shopify section to render
    }
  })();

  // ============= Predictive search =============
  (function () {
    var forms = document.querySelectorAll('form[data-brb-predictive]');
    if (!forms.length) return;

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }

    function imgSize(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    forms.forEach(function (form) {
      var input = form.querySelector('input[type="search"], input[name="q"]');
      var panel = form.querySelector('[data-predictive-panel]');
      if (!input || !panel) return;

      var timer = null;
      var ctrl = null;
      var lastQ = '';

      function close() {
        panel.hidden = true;
        panel.innerHTML = '';
        lastQ = '';
      }

      function render(q, products) {
        if (!products.length) {
          panel.innerHTML = '<div class="brb-ps-empty">Niciun rezultat pentru „' + esc(q) + '”.</div>';
          panel.hidden = false;
          return;
        }
        var html = products.map(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + esc(imgSize(p.featured_image.url, 120)) + '" alt="" loading="lazy">'
            : '<span class="brb-ps-ph"></span>';
          var price = '';
          var n = parseFloat(p.price);
          if (!isNaN(n)) price = '<span class="brb-ps-price">' + brbMoney(Math.round(n * 100)) + '</span>';
          return '<a class="brb-ps-item" href="' + esc(p.url) + '">' +
            img +
            '<span class="brb-ps-title">' + esc(p.title) + '</span>' +
            price +
          '</a>';
        }).join('');
        html += '<a class="brb-ps-all" href="/search?q=' + encodeURIComponent(q) + '">Vezi toate rezultatele <span class="arrow">→</span></a>';
        panel.innerHTML = html;
        panel.hidden = false;
      }

      function search(q) {
        if (ctrl) ctrl.abort();
        ctrl = ('AbortController' in window) ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            lastQ = q;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(q, products);
          })
          .catch(function (e) { if (e && e.name !== 'AbortError') close(); });
      }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function () { search(q); }, 250);
      });

      input.addEventListener('focus', function () {
        var q = input.value.trim();
        if (q.length >= 2 && q !== lastQ) search(q);
        else if (q === lastQ && panel.innerHTML) panel.hidden = false;
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); input.blur(); }
      });

      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) close();
      });
    });
  })();
})();
